import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import { putRequest } from '../../requestUtils';
import './WorkCompletedForProject.scss';

class WorkCompletedForProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      createInvoice: null,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    const { csrfToken, completeWorkUrl } = this.props;
    const { createInvoice } = this.state;

    putRequest(
      completeWorkUrl,
      { create_invoice: createInvoice },
      csrfToken,
    ).then(() => {
      window.location.reload();
    });
  }

  handleChange(bool) {
    this.setState({ createInvoice: bool });
  }

  render() {
    const { style, triggerText, triggerStyle } = this.props;
    const { createInvoice } = this.state;
    return (
      <ModalTrigger
        triggerText={triggerText}
        buttonStyles={`btn btn-sm ${style} ${triggerStyle}`}
        submitButtonText="Mark Work Completed"
        cancelButtonText="Cancel"
        handleSubmit={this.handleSubmit}
        submitDisabled={createInvoice === null}
        triggerType="link"
        idKey="work-completed-for-project-modal"
      >
        <div className="style-guide">
          <h2 className="mb-3">Is the consultant invoicing for the the current month?</h2>
          <div className="body-text-2 mb-3">
            If the consultant is expected to invoice any hours, please start an invoice on their
            behalf for the current month before marking the project as completed.
          </div>

          <div className="body-text-2">
            <label className="me-4 mb-2" htmlFor="create">
              <input
                type="radio"
                id="create"
                name="create"
                checked={createInvoice === true}
                onChange={() => this.handleChange(true)}
              />
              Yes, Create invoice for current month
            </label>

            <label htmlFor="dont-create">
              <input
                type="radio"
                id="dont-create"
                name="dont-create"
                checked={createInvoice === false}
                onChange={() => this.handleChange(false)}
              />
              No, Don&#39;t create invoice for the current month
            </label>
          </div>
        </div>
      </ModalTrigger>
    );
  }
}

WorkCompletedForProject.propTypes = {
  triggerText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  triggerStyle: PropTypes.string,
  style: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  completeWorkUrl: PropTypes.string.isRequired,
};

WorkCompletedForProject.defaultProps = {
  triggerText: 'Work Completed',
  triggerStyle: '',
  style: '',
};

export default WorkCompletedForProject;
